// De schakelaar "Nieuwe weergave (proef)" (frontend-afronden, 13-10). Alleen
// voor wie ook de Plan-tab ziet (beheer en accountmanagement); de keuze blijft
// in deze browser. Uit = het platform zoals het live staat, niets geladen van
// de nieuwe stijllaag.

import type { Mij } from "../contracts";
import { heeftPlanRol } from "../lib/mij";

const SLEUTEL = "summa-nieuwe-weergave";

export const magNieuw = (mij: Mij | null): boolean => heeftPlanRol(mij);

/** Welke weergave staat er? Accountmanagement en business partners zien altijd
 *  de nieuwe, zonder knop om terug te gaan; beheer kiest zelf (standaard uit). */
export const nieuwWeergave = (mij: Mij | null): boolean => magNieuw(mij) && (!mij?.isAdmin || nieuwAan());

/** Heeft deze gebruiker de knop "Nieuwe weergave"? Alleen beheer. */
export const magKiezen = (mij: Mij | null): boolean => magNieuw(mij) && !!mij?.isAdmin;

export function nieuwAan(): boolean {
  try {
    return localStorage.getItem(SLEUTEL) === "1";
  } catch {
    return false;
  }
}

/** Zet de weergave om en laadt opnieuw: de twee stijlen delen geen CSS. */
export function zetNieuw(aan: boolean): void {
  try {
    localStorage.setItem(SLEUTEL, aan ? "1" : "0");
  } catch {
    /* geen opslag: dan blijft het bij de huidige weergave */
  }
  window.location.reload();
}
